import { NgModule } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AccessibilityStatementComponent } from "./accessibility-statement.component";
import { AccessibilityStatementRoutingModule } from "./accessibility-statement-routing";

@NgModule({
    declarations: [
        AccessibilityStatementComponent
    ],
    imports: [
        AccessibilityStatementRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
    ]
})
export class AccessibilityStatementModule {}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}